<script lang="ts" setup>
	const props = defineProps<{
		isPending?: boolean
		isDeactivated?: boolean
		isExpired?: boolean
		isActive?: boolean
		metaDetails?: RecordSchema
	}>()
	const policy = computed(() => props.metaDetails as unknown as PolicyResponse)
</script>

<template>
	<div>
		<my-cover-policy-label
			label="Travel Document uploaded on activation"
			:icon="{ name: 'bold-note', dir: 'documents' }"
		/>
		<my-cover-pending-policy-placeholder
			icon-dir="documents"
			title="No Travel Document"
			:sub-title="
				isDeactivated
					? 'This staff cannot access travel document because their plan has been deactivated'
					: isPending
						? 'This travel plan has not been activated yet. Activate now to enjoy full benefits.'
						: 'The policy document can not be found.'
			"
			icon-name="clipboard-document-2"
			:is-pending="isPending || false"
			activate-text="Activate Staff"
			:use-btn="!isDeactivated"
		>
			<template #button-group>
				<div></div>
			</template>
		</my-cover-pending-policy-placeholder>

		<template v-if="isActive">
			<div
				class="relative mx-auto mt-8 flex min-h-[280px] max-w-[450px] flex-col justify-between rounded border px-3 py-8"
			>
				<p
					class="mx-auto flex min-h-[32px] w-full max-w-[226px] items-center justify-center rounded border border-purple-500 bg-purple-50 text-sm font-medium text-purple-500"
				>
					Front Page of Passport
				</p>

				<div class="mt-8 bg-purple-50 p-2">
					<img
						:src="policy?.meta?.passport_front_page || ''"
						alt="document image"
						class="h-full w-full object-contain text-sm"
						loading="lazy"
					/>
				</div>
			</div>
		</template>
	</div>
</template>
